import { render } from "./ProductEditing.vue?vue&type=template&id=58209a7e&ts=true"
import script from "./ProductEditing.vue?vue&type=script&lang=ts"
export * from "./ProductEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__